<template>
  <div class="app">
    <router-link to="/">
      <img :src="logo" class="app__logo">
    </router-link>
    <router-view v-if="pages"/>
    <app-header v-if="!hideNav"/>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AppHeader from '@/components/AppHeader';

export default {
  name: 'App',
  components: { AppHeader },
  data() {
    return {
      toastError: '',
    };
  },
  mounted() {
    this.getAppData().then(() => {
      this.initialize();
    });
  },
  methods: {
    ...mapActions(['getAppData', 'initialize']),
  },
  computed: {
    ...mapGetters(['isDark']),
    ...mapState(['pages']),
    logo() {
      return this.isDark ? '/static/svg/logo--white.svg' : '/static/svg/logo.svg';
    },
    hideNav() {
      return this.$route.name === 'Market' || this.$route.name === 'Cover';
    },
  },
};
</script>

<style lang="scss">
@font-face {
    font-family: 'GT Eesti Display';
    src: url('./assets/gt_esti_display_light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'GT Eesti Display';
    src: url('./assets/gt_esti_display_medium.woff') format('woff');
    font-weight: 500;
    font-style: normal;
}

body {
  padding: 0;
  margin: 0;
  color: #282828;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.app {
  font-family: 'GT Eesti Display', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // margin-top: 60px;

  &__logo {
    position: fixed;
    top: 35px;
    left: 44px;
    z-index: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue